import React from 'react'
import Select from 'react-select'
import {
  FormDashboardTextarea as Textarea,
  FormDashboardLabel as Label,
  FormRow,
  SaveCancel,
} from '../../../components'

const Form = () => {
  return (
    <form>
      <p className="mt-8 xl:mt-0 text-lg mb-5 font-bold font-primary xl:hidden">
        Milestone
      </p>
      <FormRow>
        <Label>Year</Label>
        <Select className="text-sm lg:w-1/2" options={[]} placeholder="Select Year" />
      </FormRow>
      <FormRow>
        <Label>Description (English)</Label>
        <Textarea
          className="w-full"
          rows={5}
          defaultValue={
            `Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. `
          }
        />
      </FormRow>
      <FormRow last>
        <Label>Description (Indonesia)</Label>
        <Textarea
          className="w-full"
          rows={5}
          defaultValue={
            `Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.`
          }
        />
      </FormRow>
      <SaveCancel />
    </form>
  )
}

export { Form }
